"use client"
import { createContext, useContext, useState, useEffect } from "react"
import i18n from "../lib/i18n"

const LanguageContext = createContext()

const supportedLangs = [
  "en",
  "es",
  "de",
  "da",
  "pt",
  "it",
  "fr",
  "pl",
  "uk",
  "ru",
]

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("en")

  useEffect(() => {
    const stored = localStorage.getItem("appLang")
    const browser = navigator.language.split("-")[0]
    const initialLang = supportedLangs.includes(stored)
      ? stored
      : supportedLangs.includes(browser)
      ? browser
      : "en"
    setLanguage(initialLang)
    i18n.changeLanguage(initialLang)
  }, [])

  const changeLanguage = (lang) => {
    if (supportedLangs.includes(lang)) {
      setLanguage(lang)
      localStorage.setItem("appLang", lang)
      i18n.changeLanguage(lang)
    }
  }

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  )
}

export const useLanguage = () => useContext(LanguageContext)
